import { Box } from '@mui/material';
import {
  ArrowTab,
  ArrowTabGroup,
  CustomTabPanel,
  PageSection,
} from '@product-framework/index';
import { SYSTEM_SETTING_FORM_VIEW } from '@product-framework/pages/ServiceProvider/constants';
import { useLocalization } from '@ui-framework/index';
import { useNavigate } from 'react-router-dom';
import InsightSetting from './InsightSetting';
import DispatchSettings from './DispatchSetting';
import ClaimsSetting from './ClaimsSetting';
import ApiKeysSetting from './ApiKeysSetting';

function SystemSettings({
  serviceProviderId,
  onChange = () => undefined,
  action,
  currentIndex,
}) {
  const { formatMessage } = useLocalization();
  const navigate = useNavigate();

  const validTab = [
    SYSTEM_SETTING_FORM_VIEW.CLAIMS,
    SYSTEM_SETTING_FORM_VIEW.DISPATCH,
    SYSTEM_SETTING_FORM_VIEW.INSIGHT,
    SYSTEM_SETTING_FORM_VIEW.APIKEY,
  ].includes(parseInt(action, 10) + 1);

  const tabValue = parseInt(validTab ? action : 0, 10);

  const onMainTabChange = newValue => {
    navigate(
      `/serviceproviders/edit/${serviceProviderId}/${
        currentIndex + 1
      }/${newValue}`,
    );
  };

  return (
    <PageSection
      label={formatMessage({
        id: 'SERVICE_PROVIDER_MODULE_SETTINGS_HEADING',
        defaultMessage: 'System Settings',
      })}>
      <Box
        sx={{
          width: {
            xs: '100%',
            md: '40%',
          },
        }}>
        <ArrowTabGroup
          value={tabValue}
          onChange={(event, newValue) => {
            onMainTabChange(newValue);
          }}>
          <ArrowTab arrowHeadArea={94} maxTabs={4} label="Claims" />
          <ArrowTab maxTabs={4} label="Dispatch" />
          <ArrowTab arrowBackArea={10} maxTabs={4} label="Insight" />
          <ArrowTab arrowBackArea={10} maxTabs={4} label="API Key" />
        </ArrowTabGroup>
      </Box>
      <Box>
        <CustomTabPanel
          value={tabValue}
          index={SYSTEM_SETTING_FORM_VIEW.CLAIMS - 1}>
          <ClaimsSetting
            serviceProviderId={serviceProviderId}
            onChange={onChange}
          />
        </CustomTabPanel>
        <CustomTabPanel
          value={tabValue}
          index={SYSTEM_SETTING_FORM_VIEW.DISPATCH - 1}>
          <DispatchSettings
            onChange={onChange}
            serviceProviderId={serviceProviderId}
          />
        </CustomTabPanel>
        <CustomTabPanel
          value={tabValue}
          index={SYSTEM_SETTING_FORM_VIEW.INSIGHT - 1}>
          <InsightSetting
            onChange={onChange}
            serviceProviderId={serviceProviderId}
          />
        </CustomTabPanel>
        <CustomTabPanel
          value={tabValue}
          index={SYSTEM_SETTING_FORM_VIEW.APIKEY - 1}>
          <ApiKeysSetting serviceProviderId={serviceProviderId} />
        </CustomTabPanel>
      </Box>
    </PageSection>
  );
}

export default SystemSettings;
